import { RESET_ALL_FILTERS } from '../appFilterAndSort/action-types';
import { accomResetFilters } from '../appFilterAndSort/actions';
import { unitIdSelector } from '../booking/booking/selectors';
import { PRE_PAYMENT } from '../booking/payment/action-types';
import { FAILURE } from '../constants';
import { getRegions } from '../data/regions/actions';
import { resetOffers } from '../offers/actions';
import { SELECT_PARK } from '../park/action-types';
import { SELECT_CHANNEL } from '../search/form/action-types';
import { searchFormRegionsNeedToBeLoadedSelector } from '../search/form/derivedSelectors';
import { addUnavailableUnitId } from '../search/results/actions';

// This is for business logic, please put analytics in analyticsMiddleware
export const middleware = (store) => (next) => (action) => {
  if (!action || !action.type) {
    return next(action);
  }

  switch (action.type) {
    case SELECT_CHANNEL: {
      const channelId = action.payload.channelId;
      const regionsNeedToBeLoaded = searchFormRegionsNeedToBeLoadedSelector(store.getState(), channelId);

      if (regionsNeedToBeLoaded) {
        getRegions(store.dispatch, channelId);
      }
      break;
    }
    case RESET_ALL_FILTERS: {
      resetOffers(store.dispatch);
      break;
    }
    case SELECT_PARK: {
      accomResetFilters(store.dispatch);
      break;
    }
    case PRE_PAYMENT + FAILURE: {
      const errorMsg = action.payload?.errors?.[0]?.message;
      const unitUnavailable =
        errorMsg === 'Sorry, this holiday is no longer available. Please try searching for another holiday';

      if (unitUnavailable) {
        const bookingUnitId = unitIdSelector(store);
        addUnavailableUnitId(store.dispatch, bookingUnitId);
      }
      break;
    }
  }

  return next(action);
};
